import SettingPopoverWrapper from './SettingPopoverWrapper';
import DisplayNotification from './DisplayNotification'; 
import TaskService from '../common/util/TaskService';
import ModuleService from '../common/util/ModuleService'; 
import React, { useState, useEffect, useContext } from "react"; 
import { 
  Dropdown, 
  Tabs,
  Tab,
} from "react-bootstrap"; 
import "../common/header/header.css";
import { convertToUSTime, modifyTimezoneString, AllPaths} from "../components/HR/TimeClock/Util"; 
import "../common/style.css";
import {
  faBell,
  faCheck, 
  faFilter, 
  faSearch, 
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"; 
import moment from "moment";
import 'moment-timezone'; 
import "bootstrap/dist/js/bootstrap"; 
import "bootstrap/dist/css/bootstrap.min.css"; 
import "bootstrap/js/src/dropdown"; 
import "../App.css"; 
import _ from "lodash"; 
import NotificationAPI from "../common/util/NotificationAPI";
import { AllNotificationsForChat} from "../Context/AppActions";
import AppContext from "../Context/AppContext";
import { OtsideClickClosingWrapper } from "../common/EmojiReactionPicker/OtsideClickClosingWrapper"; 
import { getSocket } from "../Socket";   
import { useDispatch, useSelector } from "react-redux"; 
import { getDate1, getTime1, getText, getJobId, handleNotificationHyperlink } from "../common/util/appUtils";
import AddColumn from '../common/AddColumn/add_column';
import { setAllNotificationsForChat } from '../Context/ReduxContext'; 

export default function NotificationWrapper({pullNotificationsFlag,notificationFilter,setNotifcationFilter,handleSettingChange, userInfo,history}) {
    const [open,setOpen]=useState(false)
    const AppData = useContext(AppContext);
      const { dispatch ,state} = AppData || {}; 
    const getNotificationflag = useSelector((state) => state.AppReduxContext.getNotificationFlag);
    const reduxDispatch = useDispatch();
       const socket = getSocket(); 
    const [cacheDeals, setCacheDeals] = useState([]);
    const [allJobs, setAllJobs] = useState([]);
    const [allTask, setAllTasks] = useState([]);
    const [notificationList, setNotificationList] = useState([]);
    const [chatnotificationList, setchatnotificationList] = useState([]);
    const [notificationCacheList, setNotificationCacheList] = useState([]);
    const [notifyTabKey, setNotifyTabKey] = useState("Unarchive"); 

    const handleNotificationHyperlinkClick = (e, flag) =>{
        handleNotificationHyperlink(e, history, state.AllAppUsers, state.AllAccounts, cacheDeals, allTask, dispatch, reduxDispatch, flag);
    }

    const IsEnableFilter = (type) => {
    let obj = [...notificationFilter];
    obj = obj.filter((one) => one.name == type);
    if (obj.length > 0) {
      obj = obj[0];
      return obj.isVisible;
    } else {
      return false;
    }
  };
  const getNotificationRender = (list) => {
    let obj = [...notificationFilter];
    list = [...list];
    if (!obj.All) {
      list = list.filter((one) => {
        // if (
        //   one.Type == "Reminder" &&
        //   IsEnableFilter("REMINDER")
        // ) {
        //   return one;
        // }
        if (one.Type == "Mention" && IsEnableFilter("MENTION")) {
          return one;
        }
        // else  if (one.Type == "Message" && IsEnableFilter("MESSAGE")) {
        //   return one;
        // }
        else  if (one.Type == "Attachment" && IsEnableFilter("ATTACHMENT")) {
          return one;
        }
        else if (
          one.Type == "Assignee" &&
          IsEnableFilter("ASSIGNEE")
        ) {
          return one;
        } else if (
          one.Data_For == "Task" &&
          IsEnableFilter("TASK")
        ) {
          return one;
        } else if (
          one.Data_For == "Sub Task" &&
          IsEnableFilter("TASK")
        ) {
          return one;
        } else if (
          one.Data_For == "Notes" &&
          IsEnableFilter("NOTES")
        ) {
        } else if (
          one.Data_For == "Bug" &&
          IsEnableFilter("BUG")
        ) {
          return one;
        }
      });
    }
    return list;
  }; 

    const getTotalNotifyCount = () => {
    let filterCount = notificationList.filter(
      (one) => !one.IsRead
    );
    filterCount = filterCount.filter((one) => !one.IsArchive);
    if (filterCount.length > 0) {
      return filterCount.length;
    } else {
      return "";
    }
  }; 

  const getAllResourse = () => {
      ModuleService.GetModuleList("Deals")
        .then((result) => {
          if (result.data) { 
            setCacheDeals(result.data);
          } else {
            setCacheDeals([]);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    };
     const getJobsByProjectId = (pid) => {
        TaskService.GetJobsByProjectId(pid)
          .then((result) => {
            if (result) {
              for (let i = 0; i < result.length; i++) {
                result[i].name = result[i].projectName + "-" + result[i].jobName;
              }
              setAllJobs(result);
            } else {
              setAllJobs([]);
            }
          }).catch((err) => {
            console.error(err);
          }).finally(() => {
            getAllTask();
          });
      };
  const getAllTask = () => {
      TaskService.GetMyTasks()
        .then((result) => {
          for (let i = 0; i < result.length; i++) {
            result[i].JobId = getJobId(result[i].id_string, allJobs);
          }
          setAllTasks(result);
        })
        .catch((err) => {
          console.error(err);
        });
    };
  useEffect(() => {
      if (cacheDeals.length > 0 && allTask.length > 0) {
        getNotification();
      }
    }, [cacheDeals, allTask, getNotificationflag]); 
    
  useEffect(() => { 
        pullNotifications(); 
    }, [getNotificationflag]); 

  const getNotificationWithReminderTaskTiles = async (list) => {
      list = [...list];
      const deals = [...cacheDeals];
      const tasks = [...allTask]; 
      try { 
        for (let n = 0; n < list.length; n++) {
            list[n].Text = getText(list[n].Text, "");
          if (
            list[n].Type == "Reminder" &&
            list[n].Text.includes("#$taskid")
          ) {
            for (let t = 0; t < tasks.length; t++) {
              if (
                list[n].Text.includes(
                  `taskid:${tasks[t].id_string}`
                )
              ) {
                let deal = deals.filter(
                  (d) =>
                    d.Project_ID && d.Project_ID.includes(tasks[t].project_id)
                );
                if (deal.length > 0) {
                  deal = deal[0];
                  let clientColor = await TaskService.GetClientColor(
                    deal.Account_Name.id
                  );
                  let dealColor = await TaskService.GetDealColor(deal.Stage);
                  list[n].Text = `${getText(
                    list[n].Text,
                    tasks[t].id_string
                  )} <br/><a style="color:#40a9ff" id="Task-${
                    tasks[t].id_string
                  }">${
                    tasks[t].name
                  }</a>  <a style="background-color:${clientColor}" id="Client-${
                    deal.Account_Name ? deal.Account_Name.id : ""
                  }">${
                    deal.Account_Name ? deal.Account_Name.name : ""
                  }</a>  <a style="background-color:${dealColor}" id="Deal-${
                    deal.id
                  }">${deal.Deal_Name}</a>  `;
                }
              }
            }
          }
        }
      } catch (err) {
        console.error(err);
      } 
      return list;
    };
  function pullNotifications(){
      // let count=localStorage.getItem("notificationcount")
      let count=0;
      // NotificationAPI.LiveNotificationLongPollApi(count).then(async result=>{
      NotificationAPI.AllNotificationApi().then(async result=>{ 
        localStorage.setItem("notificationcount",result?.data.length);
        result = result?.data?.filter(
          (one) => one.Reciever_Email == userInfo?.email_id
        );
        result.sort(
          (a, b) =>
            new Date(b.CREATEDTIME) -
            new Date(a.CREATEDTIME)
        );
        let chatNotifications=result.filter(chat=>{
          if((chat.Type=="Message" || chat.Type=="Chat" || chat.Type=="Attachment") && !chat.IsRead){
            return chat
          }
        })
        if(chatNotifications?.length!=chatnotificationList?.length){
          // setRefreshChat(!refreshTheChat);
          setchatnotificationList(chatNotifications);
          reduxDispatch(setAllNotificationsForChat(chatNotifications))
        }else if(chatNotifications.length == 0){
          setchatnotificationList([]);
          reduxDispatch(setAllNotificationsForChat([]))
        }
        result = await getNotificationWithReminderTaskTiles(result);
        setNotificationList(result);
        setNotificationCacheList(result);
        // setLoader(false);
      }).catch((err) => {
        // setLoader(false);
        console.error(err);
      }) 
   }
   const getNotification = () => { 
    localStorage.setItem("notificationcount",0);
    pullNotifications()
  };
  useEffect(() => {
      localStorage.setItem("notificationcount",0); 
      getAllResourse();
    //   getAllTask(); 
      getJobsByProjectId("");
    }, []);

  useEffect(() => {
    pullNotifications();
  }, [pullNotificationsFlag])
  
  return (
     <Dropdown className="notificaton"
                      show={open}
                      onToggle={e => {
                          setOpen(!open);
                      }}
                    >
                      <Dropdown.Toggle
                        id="dropdown-editcolumn"
                        className="notification-drop"
                      >
                        <FontAwesomeIcon
                          className="fontawsome-text "
                          icon={faBell} 
                        />
                        <span className="notification-count">
                          {getTotalNotifyCount()}
                        </span>
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="drop-menu-notificatn">
                        <OtsideClickClosingWrapper
                          close={e => {
                            e.stopPropagation();
                              if (open) {
                                  setOpen(!open);
                              }
                          }}
                      >
                        <div className="content-div"   onClick={(e) => {
                              e.stopPropagation(); 
                            }}>
                            Notifications
                            <SettingPopoverWrapper
                              handleSettingChange={handleSettingChange}
                              notificationFilter={notificationFilter}
                              notificationCacheList={notificationCacheList}
                              notifyTabKey={notifyTabKey}
                              getNotification={getNotification}
                            />
                          </div>

                          <div className="notificationArea">
                            <div className="notification-topMenu">
                              {notificationList.filter((one) => one.isCheck).length >
                              0 ? (
                                <div className="checkedList-actions">
                                  <div className="d-flex">
                                    <span 
                                      className="text-blue"
                                    >
                                      <FontAwesomeIcon icon={faCheck} />
                                      Mark as Read
                                    </span>

                                    <span 
                                      className="text-blue"
                                      style={{ marginLeft: "20px" }}
                                    >
                                      Mark as Unread
                                    </span>
                                  </div>

                                  <span 
                                    className="text-blue"
                                  >
                                    {" "}
                                    Cancel
                                  </span>
                                </div>
                              ) : (
                                <div>
                                  <div className="notificationFilters"> 
                                    <AddColumn
                                      Label={<FontAwesomeIcon icon={faFilter} />}
                                      columns={notificationFilter}
                                      fromNotification={true}
                                      onChangeColumn={(columns) => {
                                        setNotifcationFilter(columns);
                                      }}
                                    /> 
                                    <div className="position-relative about-deal-search notification-search-icon">
                                    <input
                                      type="text"
                                      placeholder="Search"
                                      className="pad-fix search-filter-deals"
                                      // value={SearchedItem}
                                      onChange={(e) => {
                                        let list = [...notificationCacheList];
                                        if (e.currentTarget.value) {
                                          let text =
                                            e.currentTarget.value.toLowerCase();
                                          list = list.filter((one) => {
                                            if (
                                              one.Sender_Name.toLowerCase().includes(
                                                text
                                              ) ||
                                              one.Reciever_Name.toLowerCase().includes(
                                                text
                                              ) ||
                                              one.Text.toLowerCase().includes(
                                                text
                                              ) ||
                                              one.Type.toLowerCase().includes(
                                                text
                                              ) ||
                                              one.Title.toLowerCase().includes(
                                                text
                                              )
                                            ) {
                                              return one;
                                            }
                                          });
                                        }
                                        setNotificationList(list);
                                      }}
                                    />
                                    <FontAwesomeIcon
                                      className="search-ico"
                                      icon={faSearch}
                                    />
                                  </div>
                                  </div> 
                                </div>
                              )}
                            </div>
                            <Tabs
                              activeKey={notifyTabKey}
                              onSelect={(k) => setNotifyTabKey(k)}
                              className="job-middle-tab job-middle-tabs progress-inner-tabs"
                            >
                              <Tab eventKey="Unarchive" title="Active">
                                <ul
                                  className="list-unstyled notificationList col"
                                  style={{ overflowX: "hidden" }}
                                >
                                  {getNotificationRender(
                                    notificationList.filter(
                                      (one) => {
                                        
                                        let module=notificationFilter.find(f=>f.name?.toUpperCase()==one.Type?.toUpperCase());
                                        if(module?.settingObj?.active && module.settingObj?.lastDisableTime && module.settingObj?.lastDisableTime){
                                          let notificationTime=getDate1(one.CREATEDTIME)+" "+getTime1(one.CREATEDTIME);
                                          let lastDis=modifyTimezoneString(module.settingObj?.lastDisableTime,"MM-DD-YYYY hh:mm A");
                                          let lastActive=modifyTimezoneString(module.settingObj?.lastActiveTime,"MM-DD-YYYY hh:mm A");
                                          if(!one.IsArchive 
                                            && ! moment(notificationTime).isBetween(moment(lastDis),moment(lastActive))
                                          ){
                                            return one;
                                          }
                                        }else{
                                          return one;
                                        }
                                      }
                                    )
                                  ).map((e) => (<DisplayNotification message={e} handleNotificationHyperlink={handleNotificationHyperlinkClick} getNotification={getNotification}/>))}
                                </ul>
                              </Tab>
                              <Tab eventKey="Archive" title="Archive">
                                <ul
                                  className="list-unstyled notificationList col"
                                  style={{ overflowX: "hidden" }}
                                >
                                  {getNotificationRender(
                                    notificationList.filter(
                                      // (one) => one.Notifications.IsArchive
                                      (one) => {
                                        
        let module = notificationFilter.find(
          f => f.name?.toUpperCase() === one.Type?.toUpperCase()
        );

        if (
          module?.settingObj?.active &&
          module.settingObj?.lastDisableTime &&
          module.settingObj?.lastActiveTime
        ) {
          let notificationTime =
            getDate1(one.CREATEDTIME) +
            " " +
            getTime1(one.CREATEDTIME);

          let lastDis = modifyTimezoneString(
            module.settingObj.lastDisableTime,
            "MM-DD-YYYY hh:mm A"
          );

          let lastActive = modifyTimezoneString(
            module.settingObj.lastActiveTime,
            "MM-DD-YYYY hh:mm A"
          );

          return (
            one.IsArchive &&
            !moment(notificationTime).isBetween(moment(lastDis), moment(lastActive))
          );
        }

        return one.IsArchive;
      })
    ).map((e) => (
      <DisplayNotification
        message={e}
        handleNotificationHyperlink={handleNotificationHyperlinkClick}
        getNotification={getNotification}
      />
    ))}
  </ul>
</Tab>


                            </Tabs>
                          </div>
                      </OtsideClickClosingWrapper>
                      </Dropdown.Menu>
                    </Dropdown>
  )
}
